export class Registration {
    public id?: number;
    public deleted?: boolean = false;
    public version?: number = 1;
    public company: any;
    public trainingSession: any;

    constructor(
        id: number,
        deleted: boolean,
        version: number,
        company: any,
        trainingSession: any
    ) {
        this.id = id;
        this.deleted = deleted;
        this.version = version;
        this.company = company;
        this.trainingSession = trainingSession;
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/registration/registration.model.ts